var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "CoverImg cover-img-component" }, [
    _c(
      "div",
      {
        staticClass: "cover-img",
        style: {
          "background-image": "url(" + _vm.src + ")",
          "padding-top": _vm.height_ratio * 100 + "%"
        }
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }